<template>
    <div class="forget-container">
        <div class="forget-box">
            <p class="forget-title">找回密码</p>
            <input
                class="input"
                placeholder="手机号"
                v-model="phone"
                maxlength="11"
                type="text"
                @focus="removeErr(0)"
            />
            <div v-if="errorData[0].errorTag" class="error-msg">
                {{ errorData[0].errorText }}
            </div>
            <input
                class="input"
                placeholder="身份证"
                maxlength="18"
                v-model="idCard"
                @focus="removeErr(1)"
                type="text"
            />
            <div v-if="errorData[1].errorTag" class="error-msg">
                {{ errorData[1].errorText }}
            </div>
            <input
                class="input pwd"
                placeholder="设置密码"
                v-model="password"
                type="password"
                @focus="removeErr(2)"
            />
            <div v-if="errorData[2].errorTag" class="error-msg">
                {{ errorData[2].errorText }}
            </div>
            <input
                class="input pwd"
                placeholder="确认密码"
                v-model="password1"
                @focus="removeErr(3)"
                type="password"
            />
            <div v-if="errorData[3].errorTag" class="error-msg">
                {{ errorData[3].errorText }}
            </div>
            <input
                @click="resetPwd"
                type="button"
                class="forget-btn"
                value="立即提交"
            />
        </div>
        <transition
            enter-active-class="fadeInDown"
            leave-active-class="fadeOutUp"
        >
            <eazy-toast v-show="errtipsFlag">
                <h2 v-if="errTitle" slot="title" class="eazy-toast-title">
                    {{ errTitle }}
                </h2>
                <div
                    :class="[
                        'eazy-toast-detail',
                        errTitle ? '' : 'text-success'
                    ]"
                >
                    {{ errtips }}
                </div>
            </eazy-toast>
        </transition>
    </div>
</template>
<script>
import { testPhone, testIDcard, testPassword} from "@/common/util";
import eazyToast from "@/components/common/eazytoast";
import md5 from "js-md5";
import {encrypt} from "../../common/aes";

export default {
    data() {
        return {
            phone: "",
            idCard: "",
            password: "",
            password1: "",
            cancommit: true,
            errorData: [
                {
                    errorText: "请输入正确的手机号",
                    errorTag: false
                },
                {
                    errorText: "请输入正确的身份证号",
                    errorTag: false
                },
                {
                    errorText: "请输入10~18位字母、数字、特殊字符组合",
                    errorTag: false
                },
                {
                    errorText: "两次密码不同",
                    errorTag: false
                }
            ],
            errtipsFlag: false,
            errtips: "",
            errTitle: "错误信息：",
            timmerOut: null
        };
    },
    components: {
        eazyToast
    },
    methods: {
        resetPwd() {
            this.cancommit = true;
            if (!testPhone(this.phone)) {
                this.errorData[0].errorTag = true;
                this.cancommit = false;
            }
            if (!testIDcard(this.idCard)) {
                this.errorData[1].errorTag = true;
                this.cancommit = false;
            }
            if (!testPassword(this.password)) {
                this.errorData[2].errorTag = true;
                this.cancommit = false;
            }
            if (this.password != this.password1) {
                this.errorData[3].errorTag = true;
                this.cancommit = false;
            }

            if (this.cancommit) {
                this.$ajax({
                    method: "post",
                    url: "userApi/retrievePassword",
                    data: {
                        phone: encrypt(this.phone),
                        idCard: encrypt(this.idCard),
                        password: encrypt(md5(this.password))
                    },
                    success: res => {
                        console.log(res);
                        if (this.timmerOut) {
                            clearTimeout(this.timmerOut);
                            this.timmerOut = null;
                        }
                        if (res.code == 200) {
                            this.errTitle = "";
                            this.errtips = res.message;
                            this.errtipsFlag = true;
                            this.timmerOut = setTimeout(() => {
                                this.errtipsFlag = false;
                                clearTimeout(this.timmerOut);
                                this.timmerOut = null;
                            }, 3000);
                        } else {
                            this.errTitle = "错误信息：";
                            this.errtips = res.message;
                            this.errtipsFlag = true;
                            this.timmerOut = setTimeout(() => {
                                this.errtipsFlag = false;
                                clearTimeout(this.timmerOut);
                                this.timmerOut = null;
                            }, 2000);
                        }
                    },
                    error: err => {}
                });
            }
        },
        removeErr(index) {
            this.errorData[index].errorTag = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.forget-container {
    width: 1000px;
    margin: 0 auto;
    font-size: 16px;
    color: #000;
}

.iconfont {
    font-size: 50px;
    color: red;
}

.forget-box {
    width: 353px;
    background-color: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(92, 93, 93, 0.33);
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 150px;
    text-align: center;
    overflow: hidden;
}

.forget-title {
    margin-top: 30px;
    margin-left: 50px;
    font-size: 16px;
    color: #000 !important;
    text-align: left;
}

.input {
    width: 254px;
    height: 34px;
    background-color: #ffffff;
    border: solid 1px #84b0f6;
    margin: 0 auto;
    font-size: 14px;
    text-align: left;
    margin-top: 8px;
    text-indent: 10px;
}

.accout {
    margin-top: 10px;
}

.forget-btn {
    width: 254px;
    height: 34px;
    background-color: #009cff;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: #fff;
    border: 0;
}
.error-msg {
    color: red;
    width: 254px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: left;
    margin: 0 auto;
}
.forget-btn:hover {
    background-color: #559cff;
}
// 消息标题
.eazy-toast-title {
    padding: 10px 0;
    font-size: 18px;
    font-weight: bold;
    color: red;
}
.eazy-toast-detail {
    color: #000;
}
.text-success {
    color: green;
    font-size: 18px;
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/forget.vue